import React, { useState, useEffect } from "react";
import { PollResponse } from "../types";
import { EditPoll, GetPoll, GetPollPayload, GetPollWithUserId, GetPollWithUserIdPayload, SubmitPoll } from "../utils/APIRequest";
import { STORAGE_KEYS } from "../utils/StorageKeys";
import { User } from "./MainScreen";
import { isVotingAllowed } from "../utils/timeUtils";
import LoginScreen from "./LoginScreen";
import LunchPollForm from "../components/poll/LunchPollForm";
import PollResults from "../components/poll/PollResults";
import {
    Box,
    Typography,
    Button,
    Paper,
    AppBar,
    Toolbar,
    IconButton,
} from "@mui/material"
import {
    ArrowBack as ArrowBackIcon,
    Restaurant as RestaurantIcon,
} from "@mui/icons-material"
import { useNavigate } from "react-router-dom";
const LunchPollApp: React.FC = () => {
    const [currentEmployee, setCurrentEmployee] = useState<User | null>(null);
    const [userHasVoted, setUserHasVoted] = useState<boolean>(false);
    const [pollResponses, setPollResponses] = useState<PollResponse[]>([]);
    const [currentUserPoll, setCurrentUserPoll] = useState<PollResponse | null>(null);
    const votingAllowed = isVotingAllowed()
    const navigate = useNavigate();

    const handlePollSubmit = async (
        preference: "Veg" | "Non-Veg" | null
    ) => {
        if (!currentEmployee) return;
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const pollDate = tomorrow.toISOString().split("T")[0];
        const pollPayload: any = !currentUserPoll ? {
            emp_name: currentEmployee.name,
            foodChoice: preference ?? "No",
            pollDate: pollDate,
            username: currentEmployee.id
        } : {
            foodChoice: preference ?? "No",
            pollDate: pollDate,
        }

        const response = !currentUserPoll ? await SubmitPoll(pollPayload) : await EditPoll(pollPayload)

        if (response && response?.statusCode === 200) {
            fetchPollResponses();
            setUserHasVoted(true);
            fetchCurrentUserPoll();
        }
    };

    const fetchPollResponses = async () => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const pollDate = tomorrow.toISOString().split("T")[0];

        const pollPayload: GetPollPayload = {
            date: pollDate,
        }
        const response = await GetPoll(pollPayload);

        if (Array.isArray(response)) {
            setPollResponses(response);
        } else {
            console.log("Error fetching poll responses:", response);
        }
    }

    const fetchCurrentUserPoll = async () => {
        const user = localStorage.getItem(STORAGE_KEYS.USER);
        if (user) {
            const parsedUser: User = JSON.parse(user);
            setCurrentEmployee(parsedUser);

            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            const pollDate = tomorrow.toISOString().split("T")[0];

            const pollPayload: GetPollWithUserIdPayload = {
                date: pollDate,
                username: parsedUser.id,
            }
            const response = await GetPollWithUserId(pollPayload);

            if (Array.isArray(response)) {
                setCurrentUserPoll(response[0] || null);
                setUserHasVoted(response.length > 0);
            } else {
                console.log("Error fetching poll responses:", response);
            }
        }
    }

    const handleChangeVote = () => {
        setUserHasVoted(false);
    };

    useEffect(() => {
        fetchPollResponses();
        fetchCurrentUserPoll();
    }, []);

    return (
        <Box sx={{ width: "100%" }}>
            {!currentEmployee ? (
                <LoginScreen />
            ) : (
                <>
                    {/* <AppBar position="fixed" elevation={0} sx={{ background: (theme) => theme.palette.primary.main }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={() => navigate("/")}>
                                <ArrowBackIcon />
                            </IconButton>
                            <RestaurantIcon sx={{ mr: 2 }} />
                            <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
                                Lunch Poll
                            </Typography>
                        </Toolbar>
                    </AppBar> */}

                    {/* Main Content */}
                    <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
                        <Typography variant="h5" gutterBottom>
                            Welcome, {currentEmployee.name}!
                        </Typography>

                        {!userHasVoted ? (
                            votingAllowed ?
                                <LunchPollForm onSubmit={handlePollSubmit} /> :
                                <Typography variant="body1" color="textSecondary">Your Time is Up.</Typography>
                        ) : (
                            <Box sx={{ textAlign: "center", my: 2, justifyContent: "center" }}>
                                <Typography variant="body1" gutterBottom>
                                    Thank you for your response!
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    You have already voted for {currentUserPoll?.foodChoice}.
                                </Typography>
                                {votingAllowed &&
                                    <Box sx={{ mt: 2 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            fullWidth
                                            onClick={handleChangeVote}
                                            sx={{ maxWidth: 200 }}
                                        >
                                            <Typography variant="body1" component="span" sx={{ fontWeight: "bold" }}>
                                                Change Vote
                                            </Typography>
                                        </Button>
                                    </Box>}
                            </Box>
                        )}
                    </Paper>
                </>
            )}

            <PollResults response={pollResponses} />
        </Box>
    );
};

export default LunchPollApp;